export const getFileExtensionFromPath = (path) => {
  if (!path) return '';
  const withoutQuery = String(path).split('?')[0].split('#')[0];
  const lastSegment = withoutQuery.split('/').pop() || '';
  const dotIndex = lastSegment.lastIndexOf('.');
  return dotIndex >= 0 ? lastSegment.slice(dotIndex + 1).toLowerCase() : '';
};

export const getFileNameFromPath = (path, fallback = 'Source file') => {
  if (!path) return fallback;
  const withoutQuery = String(path).split('?')[0].split('#')[0];
  const lastSegment = withoutQuery.split('/').pop();
  if (!lastSegment) return fallback;

  try {
    return decodeURIComponent(lastSegment);
  } catch (_) {
    return lastSegment;
  }
};

export const detectFileViewerType = (path, fallback = 'pdf') => {
  if (!path) return fallback;
  if (String(path).includes('audit_extracted_text.txt')) return 'text';

  const extension = getFileExtensionFromPath(path);
  if (extension === 'pdf') return 'pdf';
  if (extension === 'json') return 'json';
  if (extension === 'txt' || extension === 'log') return 'text';
  if (extension === 'csv') return 'csv';
  if (extension === 'html' || extension === 'htm') return 'html';
  if (['xlsx', 'xls', 'xlsm', 'xlsb'].includes(extension)) return 'excel';

  return fallback;
};
